// Функция всплывающих уведомлений (Toast)
window.showToast = function (message, type) {
    type = type || 'success';
    let icon = type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle';
    let bgClass = type === 'success' ? 'text-success' : 'text-danger';

    let toastHtml =
        '<div class="toast show border-0 shadow" role="alert" aria-live="assertive" aria-atomic="true">' +
            '<div class="toast-body d-flex align-items-center p-3">' +
                '<i class="fas ' + icon + ' ' + bgClass + ' fs-5 me-2"></i>' +
                '<div class="fw-bold">' + message + '</div>' +
                '<button type="button" class="btn-close ms-auto" data-bs-dismiss="toast"></button>' +
            '</div>' +
        '</div>';

    let toast = jQuery(toastHtml);
    jQuery('#toastPlacement').append(toast);

    // Плавное исчезновение через 5 секунд
    setTimeout(function () {
        toast.fadeOut(function () {
            jQuery(this).remove();
        });
    }, 5000);
}
